export const PaymentBrand = "cca";
